// src/redux/scienceOfSelf/scienceOfSelfSelectors.js

// ==================== ORIGINAL SCIENCE OF SELF SELECTORS ====================

// ✅ Create Science of Self
export const selectCreateScienceOfSelfData = (state) =>
  state?.scienceOfSelf?.createScienceOfSelf?.data;
export const selectCreateScienceOfSelfLoading = (state) =>
  state?.scienceOfSelf?.createScienceOfSelf?.loading;
export const selectCreateScienceOfSelfError = (state) =>
  state?.scienceOfSelf?.createScienceOfSelf?.error;

// ✅ Science of Self List
export const selectScienceOfSelfList = (state) =>
  state?.scienceOfSelf?.getScienceOfSelfList?.data || [];
export const selectScienceOfSelfListLoading = (state) =>
  state?.scienceOfSelf?.getScienceOfSelfList?.loading;
export const selectScienceOfSelfListError = (state) =>
  state?.scienceOfSelf?.getScienceOfSelfList?.error;
export const selectScienceOfSelfListTotal = (state) =>
  state?.scienceOfSelf?.getScienceOfSelfList?.total || 0;

// ✅ Science of Self by ID
export const selectScienceOfSelfById = (state) =>
  state?.scienceOfSelf?.getScienceOfSelfById?.data;
export const selectScienceOfSelfByIdLoading = (state) =>
  state?.scienceOfSelf?.getScienceOfSelfById?.loading;
export const selectScienceOfSelfByIdError = (state) =>
  state?.scienceOfSelf?.getScienceOfSelfById?.error;

// ✅ Update Science of Self
export const selectUpdateScienceOfSelfData = (state) =>
  state?.scienceOfSelf?.updateScienceOfSelf?.data;
export const selectUpdateScienceOfSelfLoading = (state) =>
  state?.scienceOfSelf?.updateScienceOfSelf?.loading;
export const selectUpdateScienceOfSelfError = (state) =>
  state?.scienceOfSelf?.updateScienceOfSelf?.error;

// ✅ Delete Science of Self
export const selectDeleteScienceOfSelfData = (state) =>
  state?.scienceOfSelf?.deleteScienceOfSelf?.data;
export const selectDeleteScienceOfSelfLoading = (state) =>
  state?.scienceOfSelf?.deleteScienceOfSelf?.loading;
export const selectDeleteScienceOfSelfError = (state) =>
  state?.scienceOfSelf?.deleteScienceOfSelf?.error;

// ✅ Archive Science of Self
export const selectArchiveScienceOfSelfData = (state) =>
  state?.scienceOfSelf?.archiveScienceOfSelf?.data;
export const selectArchiveScienceOfSelfLoading = (state) =>
  state?.scienceOfSelf?.archiveScienceOfSelf?.loading;
export const selectArchiveScienceOfSelfError = (state) =>
  state?.scienceOfSelf?.archiveScienceOfSelf?.error;

// ==================== SESSION MANAGEMENT SELECTORS ====================

// ✅ Add Science of Self Session
export const selectAddScienceOfSelfSessionData = (state) =>
  state?.scienceOfSelf?.addScienceOfSelfSession?.data;
export const selectAddScienceOfSelfSessionLoading = (state) =>
  state?.scienceOfSelf?.addScienceOfSelfSession?.loading;
export const selectAddScienceOfSelfSessionError = (state) =>
  state?.scienceOfSelf?.addScienceOfSelfSession?.error;

// ✅ Get Science of Self Sessions
export const selectScienceOfSelfSessions = (state) =>
  state?.scienceOfSelf?.getScienceOfSelfSessions?.data || [];
export const selectScienceOfSelfSessionsLoading = (state) =>
  state?.scienceOfSelf?.getScienceOfSelfSessions?.loading;
export const selectScienceOfSelfSessionsError = (state) =>
  state?.scienceOfSelf?.getScienceOfSelfSessions?.error;
export const selectScienceOfSelfSessionsTotal = (state) =>
  state?.scienceOfSelf?.getScienceOfSelfSessions?.total || 0;

// ✅ Enable/Disable Tool
export const selectEnableDisableToolData = (state) =>
  state?.scienceOfSelf?.enableDisableTool?.data;
export const selectEnableDisableToolLoading = (state) =>
  state?.scienceOfSelf?.enableDisableTool?.loading;
export const selectEnableDisableToolError = (state) =>
  state?.scienceOfSelf?.enableDisableTool?.error;

// ✅ Enable/Disable Assignment
export const selectEnableDisableAssignmentData = (state) =>
  state?.scienceOfSelf?.enableDisableAssignment?.data;
export const selectEnableDisableAssignmentLoading = (state) =>
  state?.scienceOfSelf?.enableDisableAssignment?.loading;
export const selectEnableDisableAssignmentError = (state) =>
  state?.scienceOfSelf?.enableDisableAssignment?.error;

// ✅ Enable/Disable Support Document
export const selectEnableDisableSupportDocumentData = (state) =>
  state?.scienceOfSelf?.enableDisableSupportDocument?.data;
export const selectEnableDisableSupportDocumentLoading = (state) =>
  state?.scienceOfSelf?.enableDisableSupportDocument?.loading;
export const selectEnableDisableSupportDocumentError = (state) =>
  state?.scienceOfSelf?.enableDisableSupportDocument?.error;

// ✅ Get Science of Self Session Details
export const selectScienceOfSelfSessionDetails = (state) =>
  state?.scienceOfSelf?.getScienceOfSelfSessionDetails?.data;
export const selectScienceOfSelfSessionDetailsLoading = (state) =>
  state?.scienceOfSelf?.getScienceOfSelfSessionDetails?.loading;
export const selectScienceOfSelfSessionDetailsError = (state) =>
  state?.scienceOfSelf?.getScienceOfSelfSessionDetails?.error;

// ✅ Enable/Disable Science of Self Session
// POST /science-of-self/sessions/enable
export const selectEnableDisableScienceOfSelfSessionData = (state) =>
  state?.scienceOfSelf?.enableDisableScienceOfSelfSession?.data;
export const selectEnableDisableScienceOfSelfSessionLoading = (state) =>
  state?.scienceOfSelf?.enableDisableScienceOfSelfSession?.loading;
export const selectEnableDisableScienceOfSelfSessionError = (state) =>
  state?.scienceOfSelf?.enableDisableScienceOfSelfSession?.error;

// ✅ Combined State Selector
export const selectScienceOfSelfState = (state) => state?.scienceOfSelf;